// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"476":"74e94e8a","666":"93faf608","1716":"3c927bb4","8120":"e872979c"}[chunkId] + ".chunk.css";
};